import { useState, useEffect } from 'react';
import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export interface SignupStats {
    day: number;
    week: number;
    month: number;
    year: number;
}

export default function useSignupStats() {
    const [stats, setStats] = useState<SignupStats | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const api = useAuthenticatedApi();

    useEffect(() => {
        const fetchStats = async () => {
            setIsLoading(true);
            try {
                const response = await api.get('/photo-engineers/signup-stats');
                setStats(response.data);
            } catch (error) {
                console.error('Error fetching signup stats:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchStats();
    }, [api]);

    return { stats, isLoading };
}
